<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99967 8.66675C8.36786 8.66675 8.66634 8.36827 8.66634 8.00008C8.66634 7.63189 8.36786 7.33342 7.99967 7.33342C7.63148 7.33342 7.33301 7.63189 7.33301 8.00008C7.33301 8.36827 7.63148 8.66675 7.99967 8.66675Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.99967 4.00008C8.36786 4.00008 8.66634 3.7016 8.66634 3.33341C8.66634 2.96522 8.36786 2.66675 7.99967 2.66675C7.63148 2.66675 7.33301 2.96522 7.33301 3.33341C7.33301 3.7016 7.63148 4.00008 7.99967 4.00008Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.99967 13.3334C8.36786 13.3334 8.66634 13.0349 8.66634 12.6667C8.66634 12.2986 8.36786 12.0001 7.99967 12.0001C7.63148 12.0001 7.33301 12.2986 7.33301 12.6667C7.33301 13.0349 7.63148 13.3334 7.99967 13.3334Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
